import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

const Placeholder = ( {icons} ) => {

    const SVG = styled.svg`
        max-width: 400px;
        max-height: 400px;
        min-height: 250px;
        min-width: 250px;
        background: #607D8B;
        background: linear-gradient(to bottom, #607D8B 0%, #ECEFF1 100%);
        width: 100%;
        height: 100%;
        flex-grow: 1;
        flex-shrink: 1;
        fill: ${(props) => props.theme.palette.blueGrey[100] };
        margin: 0 auto;
    `;

    return (
        <SVG>
            <use xlinkHref={`${icons}#icon-image-placeholder`}/>
        </SVG>
    );
};

const makeMapStateToProps = (initialState) => {
    const {icons} = initialState.icons;
    const mapStateToProps = () => {
        return {
            icons: icons,
        }
    };
    return mapStateToProps;
};

export default connect(makeMapStateToProps)(Placeholder);



// WEBPACK FOOTER //
// ./src/components/ImagePlaceholder.js